/* --- colors ------------------------------------------------- */

export const DARK_BG = '#080809';
export const NOPING_GREEN = '#93FF18';
export const ACCENT_BLUE = '#2ECDFF';
export const TEXT_LIGHT = '#E5E7EB';
export const MUTED_GRAY = '#929298';
export const CARD_DARK = '#0D0D12';

/* --- animation easing --------------------------------------- */

export const EASE_OUT = [0.25, 0.46, 0.45, 0.94] as const;
export const EASE_IN_OUT = [0.42, 0, 0.58, 1] as const;

/* --- Multiconnection route data ----------------------------- */

export interface RouteHop {
  x: number;
  y: number;
  city: string;
}

export interface RouteData {
  hops: RouteHop[];
  latencies: number[];
  total: number;
  optimal: boolean;
  packetDur: number;
}

export const MULTICONNECTION_ROUTES: RouteData[] = [
  {
    hops: [
      { x: 60, y: 25, city: 'L.A.' },
      { x: 200, y: 18, city: 'Denver' },
      { x: 340, y: 15, city: 'Chicago' },
      { x: 500, y: 20, city: 'Philly' },
      { x: 600, y: 25, city: 'D.C.' },
    ],
    latencies: [8, 12, 14, 9, 6],
    total: 49,
    optimal: false,
    packetDur: 2.5,
  },
  {
    hops: [
      { x: 60, y: 65, city: 'L.A.' },
      { x: 190, y: 55, city: 'Dallas' },
      { x: 320, y: 60, city: 'Atlanta' },
      { x: 470, y: 52, city: 'Charlotte' },
      { x: 600, y: 65, city: 'D.C.' },
    ],
    latencies: [6, 5, 7, 4, 3],
    total: 25,
    optimal: true,
    packetDur: 1.4,
  },
  {
    hops: [
      { x: 60, y: 105, city: 'L.A.' },
      { x: 210, y: 96, city: 'Phoenix' },
      { x: 350, y: 110, city: 'Houston' },
      { x: 490, y: 100, city: 'Nashville' },
      { x: 600, y: 105, city: 'D.C.' },
    ],
    latencies: [11, 15, 10, 12, 8],
    total: 56,
    optimal: false,
    packetDur: 2.8,
  },
  {
    hops: [
      { x: 60, y: 145, city: 'L.A.' },
      { x: 185, y: 138, city: 'Vegas' },
      { x: 330, y: 148, city: 'Memphis' },
      { x: 480, y: 140, city: 'Richmond' },
      { x: 600, y: 145, city: 'D.C.' },
    ],
    latencies: [9, 13, 11, 10, 7],
    total: 50,
    optimal: false,
    packetDur: 3.1,
  },
  {
    hops: [
      { x: 60, y: 185, city: 'L.A.' },
      { x: 220, y: 178, city: 'SLC' },
      { x: 370, y: 188, city: 'Minneap.' },
      { x: 510, y: 180, city: 'Detroit' },
      { x: 600, y: 185, city: 'D.C.' },
    ],
    latencies: [14, 18, 16, 13, 11],
    total: 72,
    optimal: false,
    packetDur: 3.6,
  },
];

/* --- How It Works steps ------------------------------------- */

export const HOW_IT_WORKS_STEPS = [
  { step: 1, icon: '\uD83D\uDCE5' },
  { step: 2, icon: '\uD83C\uDFAE' },
  { step: 3, icon: '\uD83D\uDCA5' },
] as const;

/* --- Stats cards -------------------------------------------- */

export const STAT_CARDS = [{ icon: '\uD83D\uDCE1' }, { icon: '\uD83D\uDD28' }, { icon: '\uD83D\uDC65' }, { icon: '\uD83C\uDF10' }] as const;

/* --- App features ------------------------------------------- */

export const APP_FEATURES = [
  { icon: '\uD83C\uDF10', color: NOPING_GREEN },
  { icon: '\u26A1', color: ACCENT_BLUE },
  { icon: '\uD83D\uDCCA', color: NOPING_GREEN },
] as const;

/* --- FAQ data ----------------------------------------------- */

export const FAQ_ITEMS_COUNT = 6;

/* --- Hero benefit badges ------------------------------------ */

export const HERO_BADGES_COUNT = 4;
